export enum OperatingSystemType {
    Windows = 'windows',
    Linux = 'linux',
}
